export default __webpack_public_path__ + "static/media/trails_icon.b573d39f.svg";